import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPayment: 0,
    totalCarts: 0,
};

const CartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addItem(state, action) {
            // implementation for adding item to cart
        },
        removeItem(state, action) {
            // implementation for removing item from cart
        },
        setTotalPayment(state, action) {
            // console.log("setTotalPayment action called with payload:", action.payload);
            state.totalPayment = action.payload;
        },
        setTotalCarts(state, action) {
            // console.log("setTotalCarts action called with payload:", action.payload);
            state.totalCarts = action.payload;
        },
    },
});

export const { addItem, removeItem, clearCart, setTotalPayment, setTotalCarts } = CartSlice.actions; // <--- corrected export
export default CartSlice.reducer;


